import { navigate } from "@reach/router"
import { localeFromPathname } from "../i18n"

export const localizePathname = (pathname: string): string => `/${localeFromPathname()}/${pathname}`

export const localizedNavigate = (pathname: string): void => {
  void navigate(localizePathname(pathname))
}

export const localizedLoadPage = (pathname: string): void => {
  document.location.pathname = pathname === "/" ? pathname : localizePathname(pathname)
}

export const loadLocalizedRoot = (): void => {
  document.location.pathname = `/${localeFromPathname()}`;
}

export const navigateTo = (pathname: string) => { document.location.pathname = pathname };

export const navigateToPortfolios = () => localizedNavigate("investment/portfolios");

export const navigateToTransactions = () => localizedNavigate("investment/transactions");

export const signOutPath = (): string => `/users/sign_out?locale=${localeFromPathname()}`;
